import React, { createContext, useContext } from 'react';

export const themes = {
  default: {
    primary: '#0d1b36',
    primary95: 'rgba(13, 27, 54, 0.95)',
    primary85: 'rgba(13, 27, 54, 0.85)',
    primary80: 'rgba(13, 27, 54, 0.80)',
    primary60: 'rgba(13, 27, 54, 0.60)',
    primary40: 'rgba(13, 27, 54, 0.40)',
    primary30: 'rgba(13, 27, 54, 0.30)',
    primary10: 'rgba(13, 27, 54, 0.10)',
    primary05: 'rgba(13, 27, 54, 0.05)',
    softBg: '#efe4cf'
  },
  green: {
    primary: '#2d4a3a',
    primary95: 'rgba(45, 74, 58, 0.95)',
    primary85: 'rgba(45, 74, 58, 0.85)',
    primary80: 'rgba(45, 74, 58, 0.80)',
    primary60: 'rgba(45, 74, 58, 0.60)',
    primary40: 'rgba(45, 74, 58, 0.40)',
    primary30: 'rgba(45, 74, 58, 0.30)',
    primary10: 'rgba(45, 74, 58, 0.10)',
    primary05: 'rgba(45, 74, 58, 0.05)',
    softBg: '#e5e9d9'
  },
  blue: {
    primary: '#1a3660',
    primary95: 'rgba(26, 54, 96, 0.95)',
    primary85: 'rgba(26, 54, 96, 0.85)',
    primary80: 'rgba(26, 54, 96, 0.80)',
    primary60: 'rgba(26, 54, 96, 0.60)',
    primary40: 'rgba(26, 54, 96, 0.40)',
    primary30: 'rgba(26, 54, 96, 0.30)',
    primary10: 'rgba(26, 54, 96, 0.10)',
    primary05: 'rgba(26, 54, 96, 0.05)',
    softBg: '#dde4ef'
  }
};

const ThemeContext = createContext(themes.default);

export const ThemeProvider = ({ name = 'default', children }) => {
  const theme = themes[name] || themes.default;
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
